<template>
  <v-container fluid class="pa-0">
    <template v-if="isAdminOrTechnician">
      <RouteListItem :node="{
        name: node.name,
        meta: {
          displayName: $t('servicesystem.pages.page_titles.job_browse_jobs'),
          icon: 'mdi-briefcase-search',
          count: 0,
          params: { filter: 'browse' }
        }
      }">
      </RouteListItem>
    </template>

    <AssignmentRouteListItem :node="node" />

    <template v-if="isAdminOrTechnician">
      <RouteListItem :node="{
        name: node.name,
        meta: {
          displayName: $t('servicesystem.pages.page_titles.job_parts_jobs'),
          icon: 'mdi-fridge-alert',
          count: 0,
          params: { filter: 'parts' }
        }
      }">
      </RouteListItem>

      <v-progress-linear v-if="StatusLoading" indeterminate height="1">
      </v-progress-linear>
      <v-divider v-else style="border-color: rgb(151 151 151 / 12%);" />
      <StatusRouteListItem v-for="(status, index) in StatusList" :key="index" :status="status" :node="node">
      </StatusRouteListItem>
      <!--
      <v-divider style="border-color: rgb(151 151 151 / 12%);" />
      <template v-for="(filter) in CustomJobListFilterList">
        <RouteListItem :key="filter.name"
                      :node="{
                        name: node.name,
                        meta: { 
                          displayName: filter.name, 
                          icon: filter.icon,
                          params: { statusId: undefined, subStatusId: undefined, filterId: filter.name },
                          query: {...filter.query, filter: undefined}
                        }
                      }">
        </RouteListItem>
      </template>
<RouteListItem :node="{
                          name: node.name,
                          meta: { 
                            displayName: 'New custom filter', 
                            icon: 'mdi-plus',
                            params: { statusId: undefined, subStatusId: undefined, filterId: 'new' },
                            query: {filter: 'filter' }
                          }
                        }">
</RouteListItem>
-->
    </template>
  </v-container>
</template>


<script>
import RouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Base.vue";
import StatusRouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Status.vue";
import AssignmentRouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Assignments.vue";

export default {
  name: "RouteListItem_Status",
  props: {
    node: Object,
  },
  components: {
    RouteListItem,
    StatusRouteListItem,
    AssignmentRouteListItem,
  },

  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {
    StatusList() {
      return this.$store.getters["LookUpStore/JobStatusList"]?.filter((x) => x.Id < 100);
    },

    StatusLoading() {
      return this.$store.getters["BackgroundUpdater/Loading"]("StatusMap");
    },

    myUserType() {
      return this.userInfo.UserTypeId;
    },
    isAdminOrTechnician() {
      return this.myUserType === 1 || this.myUserType === 2;
    },

    CustomJobListFilterList: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("CustomJobListFilterList");
      },
      set(update) {
        //console.log(update);
        this.$store.dispatch("prefrences/set_prefrence", { key: "CustomJobListFilterList", value: update });
      },
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>